import { api } from "./api_core";
import { isAuthenticated } from "../utils/auth";

export const baziApi = {
  // 八字计算 (无需认证)
  // POST /api/calculate
  calculateBazi: async (birthData) => {
    try {
      const response = await api.post("/bazi/calculate", birthData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "计算失败",
      };
    }
  },

  // 保存命盘 (需要JWT认证)
  // POST /api/save_chart
  saveChart: async (chartData) => {
    try {
      const response = await api.post("/bazi/save_chart", chartData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "保存失败",
      };
    }
  },

  // 获取用户保存的命盘 (需要JWT认证)
  // GET /api/my_charts
  getMyCharts: async () => {
    try {
      // 先检查 token 是否过期
      if (!isAuthenticated()) {
        console.log("Debug: Token expired or not found");
        return {
          success: false,
          error: "登录已过期，请重新登录",
        };
      }

      // 检查 token
      const token = localStorage.getItem("access_token");
      if (!token) {
        return {
          success: false,
          error: "未登录，请先登录",
        };
      }

      console.log("Debug: 开始获取命盘列表");
      const response = await api.get("/bazi/list");

      console.log("Debug: API响应", response.data);
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      console.error("获取命盘列表错误:", error.response || error);
      if (error.response?.status === 401) {
        localStorage.removeItem("access_token");
        return {
          success: false,
          error: "登录已过期，请重新登录",
        };
      }
      return {
        success: false,
        error: error.response?.data?.error || "获取命盘列表失败",
      };
    }
  },

  // 获取单条命盘详情 (需要JWT认证)
  // GET /api/charts/:id
  getChart: async (chartId) => {
    try {
      if (!isAuthenticated()) {
        return { success: false, error: "登录已过期，请重新登录" };
      }
      const response = await api.get(`/charts/${chartId}`);
      // 后端返回单条记录对象 (response.data)
      return { success: true, data: response.data };
    } catch (error) {
      console.error("获取命盘详情错误:", error.response || error);
      if (error.response?.status === 401) {
        localStorage.removeItem("access_token");
        return { success: false, error: "登录已过期，请重新登录" };
      }
      return { success: false, error: error.response?.data?.error || "获取命盘详情失败" };
    }
  },

  // 删除命盘 (需要JWT认证)
  // DELETE /api/charts/:id
  deleteChart: async (chartId) => {
    try {
      const response = await api.delete(`/charts/${chartId}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "删除失败",
      };
    }
  },

  // 发布八字命盘
  // POST /api/bazi/publish
  publishBaziChart: async (formData) => {
    console.log('apiService.publishBaziChart called with formData:', formData);
    try {
      const response = await api.post("/bazi/publish", formData);
      console.log('apiService.publishBaziChart success response:', response);
      return { success: true, data: response.data };
    } catch (error) {
      console.log('apiService.publishBaziChart error:', error);
      console.log('apiService.publishBaziChart error response:', error.response);
      return {
        success: false,
        error: error.response?.data?.error || "发布失败",
      };
    }
  },
};